/* eslint-disable camelcase */
import React from 'react'

interface SparkLayerPriceProps {
  productId: number
}

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace
  namespace JSX {
    interface IntrinsicElements {
      'spark-product-price': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;
    }
  }
}

const SparkLayerPrice = ({productId} : SparkLayerPriceProps): JSX.Element => {
  return (
    <spark-product-price parent-id={productId}></spark-product-price>
  )
}


export default SparkLayerPrice